<template>
  <div>
    <van-overlay :show="visible" z-index="2001" :custom-style="{backgroundColor: 'rgba(0, 0, 0, .6)'}"/>
    <van-action-sheet v-model="visible" :round="false" :overlay="false" class="custom-ship-choose">
      <a href="javascript:;" class="btn-close" @click="handleClose"></a>
      <div class="title">
        <img class="icon" src="../assets/icons/icon_ship3.png" alt="">
        <span>{{title}}</span>
      </div>
      <van-datetime-picker
        class="datetime-picker"
        ref="datetimePicker"
        v-model="defaultDate"
        type="date"
        :show-toolbar="false"
        :min-date="minDate"
        @confirm="dateConfirm"
      />
      <a href="javascript:;" class="btn-common round" @click="handleConfirm">提交</a>
    </van-action-sheet>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'BaseDatePicker',

  props: {
    visible: Boolean,
    title: {
      type: String,
      default: '选择出生日期'
    },
    minDate: Date
  },

  data () {
    return {
      defaultDate: new Date()
    }
  },

  methods: {
    handleClose () {
      this.$emit('update:visible', false)
    },
    dateConfirm (val) {
      this.handleClose()
      this.$emit('update:value', dayjs(val).format('YYYY-MM-DD'))
    },
    handleConfirm () {
      const getPicker = this.$refs.datetimePicker.getPicker()
      getPicker.confirm()
    }
  }
}
</script>

<style lang="less" scoped>
.custom-ship-choose {
  border-top: 10px solid #febc10;
  padding: 0 0 30px;
  box-sizing: border-box;
  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 60px;
    height: 60px;
    border-bottom-left-radius: 10px;
    background: #febc10 url('../assets/icons/icon_close.png') center center no-repeat;
    background-size: 34px auto;
  }
  .title {
    display: flex;
    align-items: center;
    height: 80px;
    padding: 8px 42px 0;
    font-size: 28px;
    color: #1174b8;
    .icon {
      flex: none;
      width: 36px;
      margin-right: 10px;
    }
  }
  .datetime-picker {
    margin: 12px 0;
  }
  .option-box {
    max-height: 428px;
    box-sizing: border-box;
    padding: 0 42px;
    overflow-y: auto;
  }
  .option-item {
    border-top: 1Px solid #ccc;
    font-size: 28px;
    color: #666;
    line-height: 106px;
  }
}
</style>
